/**
 * Cross-app user-facing copy that MUST read identically in both SPAs.
 *
 * Console and portal each archive/restore conferences with the same wording;
 * before this the strings were duplicated verbatim in both apps' conference
 * `show` and `archivedList` pages, free to drift apart on an edit to one. Copy
 * that is genuinely shared between the two apps belongs here; app-specific copy
 * (e.g. the console's tenant-scope prompts) stays in that app.
 */
export const conferenceCopy = {
  archiveTitle: 'Archive conference',
  /** Detail-page archive confirm (title carries the intent, body is terse). */
  archiveBody: 'Field reps will no longer see this conference in the mobile app.',
  /** List-row archive confirm (title is `Archive <name>?`, so the body adds the
   *  restore hint the terse detail-page body omits). */
  archiveBodyWithRestoreHint:
    'Field reps will no longer see this conference in the mobile app. Restore it from the archived page.',
  restoreBody: 'Field reps will see this conference in the mobile app again.',
} as const;
